import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, MessageSquareX, TrendingDown, BookX } from 'lucide-react';
export function PainSection() {
  const pains = [{
    icon: <AlertTriangle className="w-8 h-8 text-red-500 mb-4" data-id="element-195" />,
    text: 'Cortás un perfil de línea A30 y después te das cuenta que tomaste mal la medida. $22.000 a la basura. De nuevo.'
  }, {
    icon: <MessageSquareX className="w-8 h-8 text-red-500 mb-4" data-id="element-196" />,
    text: 'El cliente te pregunta el precio, vos le mandás el número y... tilde azul. Silencio. Nada.'
  }, {
    icon: <TrendingDown className="w-8 h-8 text-red-500 mb-4" data-id="element-197" />,
    text: 'Facturaste $900.000 este mes pero cuando contás lo que gastaste en materiales, te quedaron $40.000.'
  }, {
    icon: <BookX className="w-8 h-8 text-red-500 mb-4" data-id="element-198" />,
    text: 'Querés entrar a trabajar en línea A30 pero el catálogo técnico parece escrito en otro idioma.'
  }];
  return <section className="bg-[#0A0A0A] py-12 px-4" data-id="element-199">
      <div className="container mx-auto max-w-5xl" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-12" data-id="element-201">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-202">
            ¿Te está pasando esto?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-203">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-[#111111] border border-red-900/30 p-8 rounded-xl hover:border-red-500/50 transition-colors" data-id="element-204">
              {pain.icon}
              <p className="text-gray-300 text-lg leading-relaxed" data-id="element-205">
                {pain.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-206">
          <p className="text-[#D4A017] text-xl md:text-2xl italic font-medium max-w-3xl mx-auto" data-id="element-207">
            "Si te identificaste con alguno de estos puntos, no es tu culpa. Es
            que nadie te enseñó el sistema correcto."
          </p>
        </motion.div>
      </div>
    </section>;
}